/**
 * These come from node_modules/bootstrap/dist/css/bootstrap.css and are min-widths.
 * This matters because if you use a min-width as a max-width you may get inconsistencies
 * ON that breakpoint (off-by-one). Adjust accordingly.
 */
export const BreakpointNums = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};

export const Breakpoints = {
  sm: `${BreakpointNums['sm']}px`,
  md: `${BreakpointNums['md']}px`,
  lg: `${BreakpointNums['lg']}px`,
  xl: `${BreakpointNums['xl']}px`
};

export default Breakpoints;



// WEBPACK FOOTER //
// ./src/components/style/Breakpoints.style.js